export const CaptchaConfig = {
  siteKey: '0x4AAAAAADnFthvoEvzNnmHc'
};
